import React, { FunctionComponent } from "react";
import { UserProfile } from "./component";

export const UserProfileContainer: FunctionComponent = () => {
  return <UserProfile />;
};
